import React from "react";
import { Alert, Button, Modal, Select, Tag } from "antd";
import {
  formatScheduleMappingSampleValue,
  SCHEDULE_IMPORT_FIELD_CONFIG,
} from "./scheduleImportUtils";

function ScheduleColumnMappingModal({
  open,
  availableColumns = [],
  columnMapping = {},
  validationMessage = "",
  onBack,
  onCancel,
  onContinue,
  onMappingChange,
  continuing = false,
}) {
  return (
    <Modal
      title="Map Columns"
      centered
      open={open}
      onCancel={onCancel}
      footer={
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <Button onClick={onBack}>Back</Button>

          <Button type="primary" onClick={onContinue} loading={continuing}>
            Continue to Review
          </Button>
        </div>
      }
      width={900}
    >
      <div className="d-flex flex-column gap-3">
        <Alert
          type="info"
          // showIcon
          message="Map each required schedule field to a column from your uploaded file."
          description="We auto-matched any columns we recognized. Extra uploaded columns will be ignored."
          style={{ fontSize: 12, padding: "8px 12px" }}
        />

        {validationMessage ? (
          <Alert type="error" showIcon message={validationMessage} />
        ) : null}

        <div className="row g-3">
          {SCHEDULE_IMPORT_FIELD_CONFIG.map((field) => {
            const selectedColumnValue = columnMapping?.[field.key] ?? "";
            const selectedByOtherFields = new Set(
              SCHEDULE_IMPORT_FIELD_CONFIG.filter(
                (otherField) =>
                  otherField.key !== field.key &&
                  columnMapping?.[otherField.key] !== undefined &&
                  columnMapping?.[otherField.key] !== null &&
                  columnMapping?.[otherField.key] !== "",
              ).map((otherField) => columnMapping?.[otherField.key]),
            );
            const selectedColumn = availableColumns.find(
              (column) => column.value === selectedColumnValue,
            );
            const selectedSampleValue = formatScheduleMappingSampleValue(
              selectedColumn?.sampleValue,
            );

            return (
              <div key={field.key} className="col-12 col-md-6">
                <div className="border rounded-3 p-3 h-100 d-flex flex-column gap-2">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <strong>{field.label}</strong>
                    {field.required ? <Tag color="red">Required</Tag> : null}
                  </div>

                  <Select
                    value={selectedColumnValue || undefined}
                    placeholder={`Select uploaded column for ${field.label}`}
                    onChange={(value) => onMappingChange(field.key, value)}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    options={availableColumns.map((column) => ({
                      value: column.value,
                      label: column.headerLabel,
                      disabled:
                        selectedByOtherFields.has(column.value) &&
                        column.value !== selectedColumnValue,
                    }))}
                  />

                  <div className="text-muted" style={{ fontSize: 12 }}>
                    {selectedColumn ? (
                      <>
                        Source column:{" "}
                        <strong>{selectedColumn.headerLabel}</strong>
                        {selectedSampleValue ? (
                          <>
                            {" "}
                            • Sample value:{" "}
                            <strong>{selectedSampleValue}</strong>
                          </>
                        ) : (
                          <> • No sample value found</>
                        )}
                      </>
                    ) : (
                      "No column selected yet."
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
}

export default ScheduleColumnMappingModal;
